export default __webpack_public_path__ + "static/media/Ajam-nirvikalpam.6bdc8103.mp3";